import { EndpointQueryParameters } from '../../../types/strapi/strapi'

/** Populate списка отгрузок: только то, что нужно таблице, inline-edit и expanded row. */
export const defaultParams: EndpointQueryParameters = {
    sort: ['id:desc'],
    populate: {
        shipment_positions: {
            fields: [
                'documentId',
                'id',
                'labelName',
                'copies',
                'actualCopies',
                'comment',
                'floodsInAccumulation',
            ],
        },
        stamp: {
            fields: [
                'documentId',
                'id',
                'number',
                'width',
                'length',
                'floods',
                'range',
                'shape',
                'comment',
                'radius',
            ],
            populate: {
                roller: {
                    fields: ['documentId', 'roller'],
                },
                last_order: true, // StampNumber: только факт relation («Новый»)
                // nested fields с name → Strapi 400 "Invalid key name"
                tube: true,
                contractor: true,
            },
        },
        virtualStamp: {
            populate: {
                roller: {
                    fields: ['documentId', 'roller'],
                },
            },
        },
        lacquers: {
            populate: {
                type: {
                    fields: ['documentId', 'name'],
                },
            },
        },
        client: {
            fields: ['documentId', 'name'],
        },
        designer: {
            fields: ['documentId', 'username'],
        },
        user_audit: {
            populate: {
                created_by_permissions_user: {
                    fields: ['documentId', 'username'],
                },
            },
        },
        // type — для иконки статуса и hasTaskOfType; детали задач — в shipment-status-query
        tasks: {
            fields: ['type'],
        },
        machine: {
            fields: ['documentId', 'name'],
            populate: {
                // validateMachine / machineHasStampRoller читают rollers из list-данных
                rollers: {
                    fields: ['documentId'],
                },
            },
        },
        additional_machines: {
            fields: ['documentId', 'name'],
        },
        additional_jobs: {
            fields: ['documentId', 'name'],
        },
        print_job: {
            fields: [
                'documentId',
                'jobStatus',
                'cancelationReason',
                'otherCancelationReason',
                'actualFloods',
            ],
            populate: {
                material_consumptions: {
                    fields: ['documentId', 'amount', 'layerNumber'],
                    populate: {
                        material: {
                            fields: ['documentId', 'width'],
                            populate: {
                                material_type: {
                                    fields: ['documentId', 'name'],
                                },
                            },
                        },
                    },
                },
            },
        },
        materialRequirements: {
            populate: {
                material_type: {
                    fields: ['documentId', 'name'],
                },
                configurations: {
                    populate: {
                        material: {
                            fields: ['documentId', 'width'],
                            populate: {
                                // Нужны для валидации резервов в колонке «Материалы»
                                stocks: {
                                    fields: ['documentId'],
                                    populate: {
                                        stock_reserves: {
                                            fields: ['documentId', 'amount'],
                                            populate: {
                                                shipment: {
                                                    fields: ['documentId'],
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
        calculated: true,
        calculatedOnActual: true,
        order: {
            fields: ['documentId', 'id'],
        },
        form_set: {
            fields: ['documentId', 'id'],
        },
        blankPreviewFiles: {
            fields: ['documentId'],
        },
    },
}
